// extracted by mini-css-extract-plugin
export default {"Box_0":"AutocompleteSuggestions-module__Box_0--iBnIs","Overlay_0":"AutocompleteSuggestions-module__Overlay_0--QuLJW"};